import { BoltingData, DbBoltingData, LiveAnalysisDetailData } from "./types";

export const mapDbBoltingDataToBoltingData = (
  item: DbBoltingData
): BoltingData => ({
  angleInDeg: item.angle_in_deg,
  anomalyDetected: item.anomaly_detected,
  createdDate: item.created_date,
  feedback: item.feedback,
  id: item.id,
  prgNr: item.prg_nr,
  processId: item.process_id,
  productId: item.product_id,
  "productId#processId": item["product_id#process_id"],
  reconstructedTorque: item.reconstructed_torque,
  status: item.status,
  timeInSec: item.time_in_sec,
  torqueInNm: item.torque_in_nm,
  userId: item.user_id,
  loss: item.loss,
  classification: item.classification,
  classification_prediction: item.classification_prediction,
  median_angle_value: "",
  median_time_value: "",
  median_torque_angle: "",
  median_torque_time: "",
});

export const mapLiveAnalysisDataToBoltingData = (item: LiveAnalysisDetailData) : BoltingData => ({
  angleInDeg: item.angle_values,
  anomalyDetected: item.anomaly_result,
  createdDate: item.timestamp * 1000, // convert epoch time (seconds) to javascript time (milliseconds)
  feedback: "NONE",
  id: item.id,
  prgNr: "NONE",
  processId: item.process_id,
  productId: item.product_id,
  "productId#processId": `${item.product_id}#${item.process_id}`,
  reconstructedTorque: "",
  status: "OK",
  timeInSec: item.time_values,
  torqueInNm: item.torque_values,
  userId: "-",
  loss: 0,
  classification: "-",
  classification_prediction: item.classification_result === "" || item.classification_result === "-" ? "" : item.classification_result,
  median_angle_value: item["Median-Angle-Value"],
  median_time_value: item["Median-Time-Value"],
  median_torque_angle: item["Median-Torque-Angle"],
  median_torque_time: item["Median-Torque-Time"],
});